import './src/patch-console-log'

import { initApp } from './src/app'
initApp()

// get the css element "#banner .more" and add an element to it:
